import React from 'react';
import {Atom, type AtomRenderProps} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const FormFileUploadFile = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
  }: AtomRenderProps) => {
    const updatedClasses = classes.push('w-file-upload-file');
    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Uploaded File',
  showEmpty: false,
  constraints: {
    descendants: [{is: 'FormFileUploadFileName', rule: 'ExactlyOne'}],
  },
  render: FormFileUploadFile,
  fields: {children: TListOfElement},
});

export default config;
